export const lang = (key, lang) => {
  const content = {
    en: {
      title: 'Endcard to GIF',
      start_time: 'Start Time of Capturing:after the game is loaded.',
      interval_time: 'Capture Interval:',
      frames: 'Numbers to Capture:',
      quality: 'GIF Quality:',
      language: 'Language:',
      zipText_label: 'Current Creative Size：',
      zipText_max: 'Max：',
      zipText_suggest: 'Suggest less than',
      previewLabel: 'Preview',
      submitLable: 'Submit',
      cancelLable: 'Cancel',
      langEmpty: 'choose language',
      counting: 'Material size calculation （Suggest less than 1M)',
      creativeSize: 'Current Creative Size：',
      creativeMaxSize: '（Max:5M)',
      suggestSize: '（Suggest less than 1M)',
      qualityLow: 'Low',
      qualityMid: 'Middle',
      qualityHigh: 'High',
      pic: 'Pic',
      languagePlaceholder: 'choose language'
    },
    cn: {
      title: 'Endcard转GIF',
      start_time: '开始截取时间：游戏加载完成后',
      interval_time: '截取时间间隔：',
      frames: '截取张数：',
      quality: '生成gif质量：',
      language: '输出语言：',
      zipText_label: '当前素材大小：',
      zipText_max: '最大：',
      zipText_suggest: '建议小于',
      previewLabel: '预览',
      submitLable: '提交',
      cancelLable: '取消',
      langEmpty: '请选择语言',
      counting: '素材大小计算中 (建议小于1M)',
      creativeSize: '当前素材大小：',
      creativeMaxSize: '（最大：5M）',
      suggestSize: '（建议小于1M）',
      qualityLow: '低',
      qualityMid: '中',
      qualityHigh: '高',
      pic: '张',
      languagePlaceholder: '请选择语言'
    }
  }
  return content[lang][key]
}